import React, { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import confetti from "canvas-confetti";
import api from "@/lib/api";
import { JOURNEY_STAGES, stageIndex } from "@/lib/journey";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { PartyPopper } from "lucide-react";

export const useMilestones = () =>
  useQuery({ queryKey: ["milestones"], queryFn: async () => (await api.get("/buyer/milestones")).data });

export function CelebrationMoment() {
  const qc = useQueryClient();
  const { data } = useMilestones();
  const cel = data?.celebration;

  useEffect(() => {
    if (cel) {
      confetti({ particleCount: 140, spread: 80, origin: { y: 0.6 }, colors: ["#D9714E", "#3B6E64", "#F2C14E", "#ffffff"] });
    }
  }, [cel]);

  const close = async () => {
    await api.post("/buyer/celebrations/seen", { stage: cel.stage });
    qc.invalidateQueries({ queryKey: ["milestones"] });
  };
  if (!cel) return null;
  const label = JOURNEY_STAGES[stageIndex(cel.stage)]?.label || "Congratulations";
  return (
    <Dialog open onOpenChange={(o) => { if (!o) close(); }}>
      <DialogContent className="max-w-md text-center rounded-3xl" data-testid="celebration-modal">
        <DialogHeader className="items-center">
          <div className="h-14 w-14 rounded-full bg-primary/15 flex items-center justify-center mb-2"><PartyPopper className="h-7 w-7 text-primary" /></div>
          <DialogTitle className="font-heading text-2xl" data-testid="celebration-title">{label}!</DialogTitle>
          <DialogDescription className="text-base text-foreground leading-relaxed pt-2 whitespace-pre-line" data-testid="celebration-message">{cel.message}</DialogDescription>
        </DialogHeader>
        <p className="font-heading italic text-primary">— Marlene</p>
        <Button onClick={close} className="rounded-full mt-2" data-testid="celebration-close-btn">Mahalo!</Button>
      </DialogContent>
    </Dialog>
  );
}
